import { Rank } from '../../sim/defs';
import { defineEnemy, Motion } from '../schema';

/** E-M8b — ŒUF. Le compte à rebours qu'on peut désamorcer.
 *
 *  Pondu par la Pondeuse, il descend lentement vers le joueur et, deux secondes
 *  plus tard, ÉCLÔT en Larve avant de disparaître — il n'est plus alors qu'une
 *  coquille vide, donc il s'efface (`dieAfter`).
 *
 *  ── Ce qu'il enseigne ──
 *  Qu'une menace future se traite AVANT qu'elle n'existe. Vingt-cinq points de
 *  vie : une seule volée de Vulcan le crève. Le joueur qui repère les œufs et les
 *  éclate économise autant de Larves ; celui qui les ignore les affronte toutes
 *  écloses, plus bas et plus près. C'est le pendant fragile de la Pondeuse : elle
 *  apprend à couper la source, l'œuf apprend à couper le délai.
 *
 *  ── Pourquoi il descend ──
 *  Un œuf immobile en haut serait sans enjeu — on le tire à loisir. En glissant
 *  vers le joueur, il crée l'urgence : le désamorcer coûte un tir maintenant, ou
 *  une Larve qui éclôt bientôt dans les jambes.
 *
 *  ── Télégraphe court ──
 *  0,4 s : il est pondu en plein combat, pas apparu du hors-champ ; le joueur l'a
 *  vu tomber de la Pondeuse. Un long télégraphe le rendrait intouchable pendant
 *  l'essentiel de sa brève vie et retirerait toute la fenêtre de désamorçage. */
export default defineEnemy({
  id: 'oeuf',
  rank: Rank.Popcorn,
  hp: 25,
  visualRadius: 15,
  score: 40,
  telegraph: 0.4,
  drops: 0,
  // Descend puis se fige bas (Anchor) : il approche du joueur pendant qu'il
  // couve, ce qui donne l'urgence, puis attend son éclosion s'il survit.
  motion: { kind: Motion.Anchor, speed: 95, holdY: -40 },
  brood: {
    // Il éclôt en LARVE — une seule fois — puis s'efface : une coquille vide n'a
    // rien à faire en scène.
    enemy: 'larve',
    every: 2.0,
    max: 1,
    dieAfter: true,
  },
});
